/**
 * @prettier
 * @flow
 */
import * as React from 'react';
import { FormProvider } from 'react-hook-form';

type Props = {|
    form: any,
    onSubmit?: any,
    className?: any,
    children?: any,
|};

export function Form({ form, onSubmit, className, children }: Props) {

    return (
        <FormProvider {...form} >
            <form onSubmit={form.handleSubmit(onSubmit)} noValidate className={className}>
                {children}
            </form>
        </FormProvider>
    );
}
